import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function GuidesPreview() {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5001';

  useEffect(() => {
    const fetchLatestBlogs = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/blogs`);
        if (res.ok) {
          const data = await res.json();
          // Take only latest 3
          setBlogs(data.slice(0, 3));
        }
      } catch (err) {
        console.error('Failed to fetch home blogs:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchLatestBlogs();
  }, [API_BASE]);

  const categoryColors: Record<string, string> = {
    'Study Tips': 'bg-emerald-600',
    'Exam Prep': 'bg-orange-500',
    'Computer Science': 'bg-slate-700',
    'News': 'bg-rose-500',
    'Guides': 'bg-amber-500',
  };

  return (
    <section className="py-20" style={{ backgroundColor: '#f8fafc' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-2 block">
              Blogs
            </span>
            <h2 className="text-3xl font-extrabold text-slate-800" style={{ fontFamily: "'Inter', sans-serif" }}>
              Latest Insights & Blogs
            </h2>
          </div>
          <Link to="/blog" className="hidden sm:flex items-center gap-1 text-sm font-medium text-emerald-700 hover:text-emerald-800 transition-colors cursor-pointer whitespace-nowrap">
            Explore the blog <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {loading ? (
             <div className="flex items-center justify-center py-20">
                <i className="ri-loader-4-line animate-spin text-3xl text-emerald-600"></i>
             </div>
        ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogs.map((blog) => (
                <Link
                key={blog.id}
                to={`/blog/${blog.slug}`}
                className="group bg-white rounded-3xl overflow-hidden border border-slate-100 transition-all duration-300 cursor-pointer block hover:shadow-2xl hover:shadow-slate-200/50 hover:-translate-y-2"
                style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}
                >
                <div className="relative h-56 overflow-hidden">
                    <img 
                        src={blog.coverImage || 'https://readdy.ai/api/search-image?query=blog%20article%20educational&width=600&height=360'} 
                        alt={blog.title} 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    <span className={`absolute top-4 left-4 ${categoryColors[blog.category] || 'bg-slate-900'} text-white text-[10px] font-bold uppercase tracking-wider px-3.5 py-1.5 rounded-full`}>
                        {blog.category || 'Article'}
                    </span>
                </div>
                <div className="p-7">
                    <h3 className="text-slate-800 font-bold text-lg leading-snug mb-4 group-hover:text-emerald-700 transition-colors line-clamp-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                        {blog.title}
                    </h3>
                    <div className="flex items-center justify-between pt-4 border-t border-slate-50 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
                    <span className="flex items-center gap-1.5"><i className="ri-calendar-line"></i> {new Date(blog.createdAt).toLocaleDateString()}</span>
                    <span className="flex items-center gap-1.5"><i className="ri-time-line"></i> {Math.ceil(blog.content.split(' ').length / 200)} min read</span>
                    </div>
                </div>
                </Link>
            ))}
            </div>
        )}

        {blogs.length === 0 && !loading && (
             <div className="text-center py-10 text-slate-400 text-sm">No articles available yet.</div>
        )}

        <div className="text-center mt-12 sm:hidden">
          <Link to="/blog" className="text-sm font-bold text-emerald-700 cursor-pointer flex items-center justify-center gap-2">
            Explore the blog <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
